import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FaqSection } from './components/FaqSection';
import { PricingSection } from './components/PricingSection';
export function App() {
  return <div className="min-h-screen bg-noir-bg text-noir-text font-sans selection:bg-noir-alert/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <MechanismSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <HowItWorksSection data-id="element-6" />
        <AudienceSection data-id="element-7" />
        <FaqSection data-id="element-8" />
        <PricingSection data-id="element-9" />
      </main>

      <footer className="py-8 bg-noir-bg border-t border-noir-border text-center text-noir-muted text-xs font-mono uppercase tracking-widest" data-id="element-10">
        <div className="container mx-auto px-4" data-id="element-11">
          <p data-id="element-12">
            FILE CLOSED. © {new Date().getFullYear()} Expediente Pareja. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}